import React from "react";
import classnames from "classnames";

import { useAnswerContext } from "contexts/answerContext";
import { useCurrentTenant } from "contexts/currentTenant";
import { getAnswer } from "queries/projects";
import { getIsZoningEnabled } from "reducers/projects";
import { getMunicipalityType, getZoningClearanceHeader } from "reducers/tenant";
import { isPresent } from "utils/func";
import { getUse } from "utils/useCode";
import { getPermission } from "utils/zoning";

import ParcelDetails from "./ParcelDetails";
import ZoneDetails from "./ZoneDetails";
import styles from "./ZoningDetails.scss";

const ZoningDetails = () => {
  const { record: project } = useAnswerContext();
  const tenant = useCurrentTenant();

  const zoning = getAnswer(project, "zoning");
  const address = getAnswer(project, "address");
  const useCode = getUse(getAnswer(project, "project_type") || {});

  if (!address) return null;

  const hasPermission = isPresent(getPermission(zoning));

  const municipalityType = getMunicipalityType(tenant);
  const isZoningEnabled = getIsZoningEnabled(project);
  const zoningClearanceHeader = getZoningClearanceHeader(tenant);

  return (
    <div className={classnames(styles.container)}>
      {hasPermission && (
        <ZoneDetails
          zoning={zoning}
          useCode={useCode}
          isZoningEnabled={isZoningEnabled}
          zoningClearanceHeader={zoningClearanceHeader}
        />
      )}
      {isPresent(zoning) && <ParcelDetails zoning={zoning} municipalityType={municipalityType} />}
    </div>
  );
};

export default ZoningDetails;
